import { getSelectedTable } from "./getSelectedTable";
import { getAllTable } from "./getAllTable";
import store from "../store";
import { correctStr, correctNum } from "./correct";
import { removeCommas } from "./commas";
import { getNormalizeDate } from "./getNormalizeDate";
import { getGarPolzZakActual } from "./getGarPolzZakActual";
import { getClientSituation } from "./getClientSituation";
import { session } from "./session";
import { getcurrentURL } from "../components/api/localglobal";
import { sendRequestProtocols } from "../axios";
import { Swal } from "sweetalert2";
import { DeepCopy } from "./DeepCopy";

export const saveReportData = async (selectedTable = false) => {
  const table = selectedTable ? getSelectedTable() : getAllTable();
  const newTable = DeepCopy(table).map(item => {
    item.bank_logo = null;
    return item;
  });
  const ReportData = {
    table: newTable,
    user_id: Number(store.getters.user_id),
    firm_id: Number(store.getters.getMyOrganisation.id),
    client_inn: Number(correctStr(store.getters.calc.client_inn)),
    client_address: correctStr(store.getters.calc.client_address),
    client_name: correctStr(store.getters.calc.client_name),
    client_kpp: correctStr(store.getters.calc.client_kpp),
    client_ogrn: correctStr(store.getters.calc.client_ogrn),
    purchase_number: correctStr(store.getters.calc.purchase_number),
    lot_number: correctStr(store.getters.calc.lot),
    customer: correctStr(store.getters.calc.customer),
    customer_inn: Number(correctStr(store.getters.calc.customer_inn)),
    customer_kpp: correctStr(store.getters.calc.customer_kpp),
    customer_ogrn: correctStr(store.getters.calc.customer_ogrn),
    customer_adres: correctStr(store.getters.calc.customer_adres),
    dogovor_subject: correctStr(store.getters.calc.dogovor_subject),
    nmkc:
      typeof store.getters.calc.nmkc === "string"
        ? removeCommas(store.getters.calc.nmkc)
        : store.getters.calc.nmkc !== null
        ? store.getters.calc.nmkc
        : 0, // get string | number send to server only number
    price_predlog:
      typeof store.getters.calc.winprice === "string"
        ? removeCommas(store.getters.calc.winprice)
        : typeof store.getters.calc.winprice === "number"
        ? store.getters.calc.winprice
        : 0, // get string | number send to server only number
    decrision_of_price: correctNum(store.getters.calc.decrision_of_price),
    date_isp_dog: store.getters.calc.date3
      ? getNormalizeDate(store.getters.calc.date3, "en")
      : null,
    date_finish_dogovor: store.getters.calc.date4
      ? getNormalizeDate(store.getters.calc.date4, "en")
      : null,
    date_final_protocol: store.getters.calc.date5
      ? getNormalizeDate(store.getters.calc.date5, "en")
      : null,
    summ: removeCommas(store.getters.calc.summ), // get string | number send to server only number
    date_from: store.getters.calc.date
      ? getNormalizeDate(store.getters.calc.date, "en")
      : null,
    date_to: store.getters.calc.date2
      ? getNormalizeDate(store.getters.calc.date2, "en")
      : null,
    trebUvelSumm: store.getters.calc.trebUvelSumm,
    trebUvelSumm2: store.getters.calc.trebUvelSumm2,
    days: store.getters.calc.days,
    purchase: correctStr(store.getters.calc.purchasesVal),
    quarantee: correctStr(store.getters.calc.quaranteesVal),
    bs: correctStr(store.getters.calc.isBS),
    avans: correctStr(store.getters.calc.isAvans),
    gar_form_zak: correctStr(store.getters.calc.isGarFormZak),
    original_paper: correctStr(store.getters.calc.isPaper),
    // your_situationsVal
    // gar_polz_zaksVal
    // gar_polz_zak: getGarPolzZakActual().id,
    gar_polz_zaksVal: store.getters.calc.gar_polz_zaksVal,
    // situation: String(getClientSituation()),
    situation: store.getters.calc.your_situationsVal,
    agent_fio: String(
      `${store.getters.profile.name} ${store.getters.profile.famil}`
    ),
    agent_position: String(`специалист по госзакупкам `),
    agent_email: String(store.getters.profile.emailContact),
    agent_phone: String(`тел.: ${store.getters.profile.phone}`),
    session: await session(),
    action: "save",
    note: String(store.getters.calc.note),
    smp: String(store.getters.calc.smp),
    itogs: Number(correctNum(store.getters.calc.itogs))
  };

  // OLD
  // await sendRequest("api/xlsme", "post", ReportData, () => {
  //   Swal.fire({
  //     icon: "warning",
  //     title: "Внимание",
  //     text: "Произошел сбой сохранения расчета"
  //   });
  // });
  await sendRequestProtocols(
    `calcregister/save`,
    "post",
    ReportData,
    () => {
      Swal.fire({
        icon: "warning",
        title: "Внимание",
        text: "Произошел сбой сохранения расчета"
      });
    }
  );
};
